import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '@env/environment';
import { AppError } from '@shared/bloc/errors';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class SentryErrorHandlerService implements ErrorHandler {
  constructor() { }

  handleError(error: any): void {
    const isHttpError = error instanceof AppError || error instanceof HttpErrorResponse;
    const isChunkLoadError = error?.name === 'ChunkLoadError' || error?.originalError?.name === 'ChunkLoadError';
    if (environment.production && !isHttpError && !isChunkLoadError) {
      Sentry?.captureException(error?.originalError || error);
    }
    console.error(error)
  }
}
